import { Component, inject, OnInit, signal, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from 'sham-components/services';
import { TranslateService } from '@ngx-translate/core';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private langService = inject(LanguageService);
  private translate = inject(TranslateService);
  private dashData = inject(ShamDashboardData);

  constructor() {
    // Listen for language changes and update the dashboard layout
    this.translate.onLangChange.subscribe(() => {
      dashboardLayoutDataFactory(this.dashData, this.translate);
    });
  }

  ngOnInit(): void {
    this.langService.init();
    // In case it was already loaded or to ensure it's set initially
    if (this.translate.currentLang) {
      dashboardLayoutDataFactory(this.dashData, this.translate);
    }
  }
  protected readonly title = signal('super-admin-dashboard');
}
